// CBV v4 : floating bar independante en bas
(function injectStickyStyles() {
  if (document.getElementById('cbv-floating-cart-styles')) return;
  var style = document.createElement('style');
  style.id = 'cbv-floating-cart-styles';
  style.textContent = ".cbv-floating-cart-bar{position:fixed;left:0;right:0;bottom:0;width:100%;z-index:9999;background-color:#faf6ef;border-top:1px solid rgba(28,24,21,.14);padding:12px 0;box-shadow:0 -10px 28px -10px rgba(28,24,21,.20);transform:translateY(110%);transition:transform 320ms cubic-bezier(.22,1,.36,1);pointer-events:none;visibility:hidden}.cbv-floating-cart-bar.is-visible{transform:translateY(0);pointer-events:auto;visibility:visible}.cbv-floating-cart-bar__inner{max-width:1400px;margin:0 auto;padding:0 20px;display:flex;align-items:center;justify-content:center;gap:12px;box-sizing:border-box}.cbv-floating-cart-bar__btn{width:100%;max-width:520px;min-height:48px;font-size:15px;font-weight:500;display:inline-flex;align-items:center;justify-content:center;gap:8px;background-color:#1c1815;color:#faf6ef;border:0;border-radius:0;padding:0 20px;cursor:pointer;transition:background-color 180ms ease,opacity 180ms ease;font-family:inherit;letter-spacing:.01em}.cbv-floating-cart-bar__btn:hover{background-color:#2a2520}.cbv-floating-cart-bar__btn:disabled{opacity:.55;cursor:not-allowed}sticky-add-to-cart{display:contents}@media (prefers-reduced-motion:reduce){.cbv-floating-cart-bar{transition:none}}@media (max-width:749px){.cbv-floating-cart-bar{padding:10px 0}.cbv-floating-cart-bar__inner{padding:0 14px;gap:10px}.cbv-floating-cart-bar__btn{font-size:14px;min-height:46px;max-width:none}}";
  document.head.appendChild(style);
})();

class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    if (this.dataset.cbvInit === 'true') return;
    this.dataset.cbvInit = 'true';
    requestAnimationFrame(() => this.setup());
  }

  setup() {
    var realBtn = this.querySelector('button[name="add"]') || this.querySelector('button[type="submit"]');
    if (!realBtn) {
      var form = this.closest('form') || document.querySelector('form[action*="/cart/add"]');
      if (form) realBtn = form.querySelector('button[name="add"]') || form.querySelector('button[type="submit"]');
    }
    if (!realBtn) return;
    if (document.querySelector('.cbv-floating-cart-bar')) return;

    var bar = document.createElement('div');
    bar.className = 'cbv-floating-cart-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Ajout rapide au panier');

    var inner = document.createElement('div');
    inner.className = 'cbv-floating-cart-bar__inner';

    var floatBtn = document.createElement('button');
    floatBtn.type = 'button';
    floatBtn.className = 'cbv-floating-cart-bar__btn';
    floatBtn.innerHTML = '<span>Ajouter au panier</span>';

    floatBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      realBtn.click();
    });

    inner.appendChild(floatBtn);
    bar.appendChild(inner);
    document.body.appendChild(bar);

    function syncDisabled() {
      var isDisabled = realBtn.disabled || realBtn.hasAttribute('disabled');
      floatBtn.disabled = isDisabled;
      var lbl = (realBtn.textContent || '').toLowerCase();
      if (isDisabled && (lbl.indexOf('rupture') !== -1 || lbl.indexOf('epuis') !== -1 || lbl.indexOf('sold') !== -1)) {
        floatBtn.innerHTML = '<span>Rupture de stock</span>';
      } else {
        floatBtn.innerHTML = '<span>Ajouter au panier</span>';
      }
    }
    syncDisabled();
    var mo = new MutationObserver(syncDisabled);
    mo.observe(realBtn, { attributes: true, attributeFilter: ['disabled'] });
    document.addEventListener('variant:change', syncDisabled);
    document.addEventListener('change', function(e){
      if (!e.target) return;
      var name = (e.target.name || '').toLowerCase();
      if (name === 'id' || name.indexOf('option') !== -1) setTimeout(syncDisabled, 60);
    });

    if (!('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    var btnOutAndAbove = false;
    var footerVisible = false;

    function updateBar() {
      if (btnOutAndAbove && !footerVisible) bar.classList.add('is-visible');
      else bar.classList.remove('is-visible');
    }

    var btnIo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        btnOutAndAbove = !e.isIntersecting && e.boundingClientRect.top < 0;
      });
      updateBar();
    }, { threshold: 0 });
    btnIo.observe(realBtn);

    var footer = document.querySelector('[data-ref="footer"]') || document.querySelector('footer');
    if (footer) {
      var footerIo = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) { footerVisible = e.isIntersecting; });
        updateBar();
      }, { threshold: 0 });
      footerIo.observe(footer);
    }
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
